import {Component} from "@webreact/webreactor"
import Plyr from "plyr"
import "plyr/dist/plyr.css"

export default class WrPlyr extends Component {
    static target = '.js-plyr'
    static _name = 'Plyr'

    constructor() {
        super()
        this.plyrs = document.querySelectorAll('.js-plyr')
        this.initialized = false
    }

    onIntersect(entries, observer) {
        if (!entries[0].isIntersecting || this.initialized) {
            return
        }

        this.initPlyrs()
        this.initialized = true
    }

    initPlyrs() {
        if (!this.plyrs) {
            return
        }

        this.plyrs.forEach(plyr => {
            new Plyr(plyr)
        })
    }
}